import { LBtn } from "@components";
import { useModal } from "@services/ModalContext";

export const CalendarFooter = ({ loading }: CalendarFooterProps): JSX.Element => {
    const { closeModal, onConfirm } = useModal();

    return (
        <div className="is-flex is-flex-direction-row is-justify-content-space-between">
            <LBtn variation="unstyled" onClick={closeModal} isBold>
                Skip
            </LBtn>
            <LBtn onClick={onConfirm} isBold loading={loading}>
                Select Date
            </LBtn>
        </div>
    );
};

interface CalendarFooterProps {
    loading?: boolean;
}
